import type { KdsRoundTableSeatPersona } from '@/kds/components/KdsRoundTable.parts/types';
import { DEFAULT_QUOTES } from '@/kds/components/KdsRoundTable.parts/messages';

/**
 * Six built-in demo personas used by KdsRoundTable when no `personas` prop is passed.
 * Quotes are sourced from `messages.ts` to allow consumer overrides via the `quotes` prop.
 * Validation by PO post-merge is recommended (see spec question #4).
 */
export const DEMO_PERSONAS: KdsRoundTableSeatPersona[] = [
  {
    name: 'Maya Chen',
    personaId: 'P-1',
    segment: 'moss',
    quote: DEFAULT_QUOTES[0]!
  },
  {
    name: 'Lior Ben-David',
    personaId: 'P-2',
    segment: 'slate',
    quote: DEFAULT_QUOTES[1]!
  },
  {
    name: 'Farida Osei',
    personaId: 'P-3',
    segment: 'clay',
    quote: DEFAULT_QUOTES[2]!
  },
  {
    name: 'Tom Eriksson',
    personaId: 'P-4',
    segment: 'fog',
    quote: DEFAULT_QUOTES[3]!
  },
  {
    name: 'Priya Nair',
    personaId: 'P-5',
    segment: 'rose',
    quote: DEFAULT_QUOTES[4]!
  },
  {
    name: 'Carlos Reyes',
    personaId: 'P-6',
    segment: 'sand',
    quote: DEFAULT_QUOTES[5]!
  }
];
